<div *ngIf="djiFlights.length > 0" class="p-3 rounded border bg-canvas">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <span class="fw-medium"><i class="bi bi-broadcast me-2"></i>Recorded by DJI</span>
    <span class="badge bg-secondary">{{ djiFlights.length }} {{ djiFlights.length === 1 ? 'flight' : 'flights' }}</span>
  </div>

  <div class="row g-3 small">
    <div class="col-6 col-md-3">
      <div class="text-muted">Acres sprayed</div>
      <div class="fw-medium">{{ acres(totals.totalAcres) }}</div>
      <div class="text-muted">
        logged {{ logged.acreageSprayed | number: '1.1-1' }} ac<ng-container *ngIf="acreageComparison as c">
          ({{ differenceLabel(c.differencePercent) }})</ng-container>
      </div>
    </div>

    <div class="col-6 col-md-3">
      <div class="text-muted">Number of flights</div>
      <div class="fw-medium">{{ djiFlights.length }}</div>
      <div class="text-muted">
        <ng-container *ngIf="logged.numFlights != null; else notEntered">logged {{ logged.numFlights }}</ng-container>
        <ng-template #notEntered>logged: not entered</ng-template>
      </div>
    </div>

    <div class="col-6 col-md-3">
      <div class="text-muted">Applied</div>
      <div class="fw-medium">{{ appliedTotal }}</div>
      <div class="text-muted">{{ duration(totals.totalSeconds) }} in the air</div>
    </div>

    <div class="col-6 col-md-3">
      <div class="text-muted">Average speed</div>
      <div class="fw-medium">
        <span *ngIf="averageSpeed === '—' && anyProcessing; else knownSpeed" class="text-muted fst-italic">Pending</span>
        <ng-template #knownSpeed>{{ averageSpeed }}</ng-template>
      </div>
      <div class="text-muted">
        <ng-container *ngIf="logged.flightSpeed != null; else noLoggedSpeed">logged {{ logged.flightSpeed }} mph</ng-container>
        <ng-template #noLoggedSpeed>logged: N/A</ng-template>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <div class="small">
    <div *ngFor="let flight of djiFlights; let i = index; trackBy: trackByIntake" class="d-flex flex-wrap align-items-center gap-3 py-1">
      <span class="fw-medium">Flight {{ i + 1 }}</span>
      <span class="text-muted" *ngIf="flight.flightStartedAt">{{ startLabel(flight) }}</span>
      <span class="text-nowrap">{{ duration(flight.durationSeconds) }}</span>
      <span class="text-nowrap">{{ acres(flight.workAreaAcres) }}</span>
      <span class="text-nowrap">{{ applied(flight) }}</span>
      <span
        class="badge ms-auto"
        [ngClass]="{
          'bg-success': flight.detailStatus === 'ready',
          'bg-warning text-dark': flight.detailStatus === 'processing',
          'bg-secondary': flight.detailStatus === 'unavailable'
        }"
      >
        <span *ngIf="flight.detailStatus === 'processing'" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        {{ statusLabel(flight.detailStatus) }}
      </span>
    </div>
  </div>

  <p *ngIf="anyProcessing" class="small text-muted mt-2 mb-0">
    Detailed flight data, including average speed, can arrive a little after the flight summary.
    <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="refresh.emit()">Refresh</button>
  </p>
</div>
